module.exports = __webpack_public_path__ + "static/media/logo.a32c8349.png";